import React, { useEffect, useState, useRef, createRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import MultiRangeSlider from "multi-range-slider-react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { UserDetailsSchema } from "../../schema";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
// import axios from 'axios';

import {
  AddHallofFame,
  AddSuperLooper,
  AddCourtesy,
  addUser,
  getAllCity,
  getAllConnectivity,
  getAllCountry,
  getAllLanguage,
  getAllState,
  getAllVoiceType,
  getDirector,
  getEngineer,
  getProducer,
  getAgent,
  getRecordingstudio,
  getVoiceTalent,
} from "../../api";
import { useSelector } from "react-redux";
import Select from "react-select";

const initialValues = {
  // ProfileDetails
  uploadimg: "",
  UserEmail: "",
  firstName: "",
  experience: "",
  lastName: "",
  gender: "",
  country: "",
  country_code: "",
  state: "",
  state_code: "",
  city: "",
  voice_languages: [],
  chosenLanguage: [],
  voice_types: [],
  chosenVoice: [],
  user_type: "",
  user_role: "",
  age_Range: "",
  chosenAge_Range: "",

  // SocialDetails
  facebook: "",
  instagram: "",
  website: "",

  // Agent Details
  agent_name: "",
  agency_name: "",
  agent_telephone: "",
  agent_email: " ",
  website1: " ",
  agent_address: "",

  // other Speciality
  speciality: [],
  specialityChosen: [],
  badge_status: "",
  union: "",
  home_studio: "",
  Connectivity: [],
  chosenConnectivity: [],
  discoverable: "",

  ishalloffame: false,
  issuperlooper: false,
  iscourtesy: false,
  halloffamedropdown: "",
  selectedCheckbox: [],
};

const UserDetails = () => {
  const { profileData, token } = useSelector((state) => state.profileReducer);
  const [isAgent, setIsAgent] = useState(false);
  const [minValue, setMinValue] = useState(25);
  const [maxValue, setMaxValue] = useState(75);
  const [minValue2, setMinValue2] = useState(0);
  const [maxValue2, setMaxValue2] = useState(0);
  const [isAgentEmailInput, setIsEmailAgentInput] = useState(false);
  const [isAgentTelephoneInput, setIsAgentTelephone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCoun, setSelectedCoun] = useState("");
  const [selectedCounCode, setSelectedCounCode] = useState("");
  const [states, setStates] = useState([]);
  const [selectedStat, setSelectedStat] = useState("");
  const [selectedStatCode, setSelectedStatCode] = useState("");
  const [cities, setCities] = useState([]);
  const [image, setImage] = useState("");
  const [cropData, setCropData] = useState("#");
  const cropperRef = createRef();
  const [disableHOF, setDisableHOF] = useState(null);
  const [disableCourtesy, setDisableCourtesy] = useState(null);

  const moment = require("moment");

  const toast = useRef(null);

  const getErrorMessage = (err, fallback = "Unable to add user") => {
    const data = err?.response?.data;

    if (typeof data === "string") return data;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    if (Array.isArray(data?.errors) && data.errors.length) {
      return data.errors
        .map((error) => error?.message || error?.msg || error)
        .filter(Boolean)
        .join(", ");
    }

    return err?.message || fallback;
  };

  const convertBase64ToImage = (uri) => {
    const splitDataURI = uri?.split(",");

    if (splitDataURI.length > 1) {
      const byteString =
        splitDataURI[0].indexOf("base64") >= 0
          ? atob(splitDataURI[1])
          : decodeURI(splitDataURI[1]);
      const type = splitDataURI[0].split(":")[1].split(";")[0];

      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i += 1)
        ia[i] = byteString.charCodeAt(i);

      const imageBlob = new Blob([ia], { type });
      const imageFile = new File([imageBlob], "live-pic.jpeg", { type });

      return imageFile;
    }
    return null;
  };

  const addUserHandler = async (values, action) => {
    const croppedImage = convertBase64ToImage(cropData);
    const formData = new FormData();
    if (croppedImage) {
      formData.append("profile_pic", croppedImage);
    }
    formData.append("email", values.UserEmail);
    formData.append("first_name", values.firstName);
    formData.append("last_name", values.lastName);
    formData.append("experience", values.experience);
    formData.append("gender", values.gender);
    formData.append("country", selectedCoun);
    formData.append("country_code", selectedCounCode);
    formData.append("state", selectedStat);
    formData.append("state_code", selectedStatCode);
    formData.append("city", values.city);
    formData.append(
      "voice_languages",
      values.chosenLanguage.map((ele) => ele.id).join(",")
    );
    formData.append(
      "voice_types",
      values.chosenVoice.map((ele) => ele.id).join(",")
    );
    formData.append("type", values.user_type);
    formData.append("role", values.user_role);
    formData.append("facebook", values.facebook);
    formData.append("instagram", values.instagram);
    formData.append("website", values.website);
    formData.append("agent_name", values.agent_name);
    formData.append("agency_name", values.agency_name);
    formData.append("agent_telephone", values.agent_telephone);
    formData.append("agent_website", values.agent_website);
    formData.append("agent_email", values.agent_email);
    formData.append("address", values.address);
    formData.append("min_age", minValue2);
    formData.append("max_age", maxValue2);
    formData.append(
      "specialties",
      values.specialityChosen.map((ele) => ele.id).join(",")
    );
    formData.append("badges", values.badge_status);
    formData.append("union", values.union);
    formData.append("home_studio", values.home_studio);
    formData.append(
      "connectivities",
      values.chosenConnectivity.map((ele) => ele.id).join(",")
    );
    formData.append("discoverable", values.discoverable);

    await addUser(formData, token)
      .then((res) => {
        setIsLoading(true);

        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        if (values.selectedCheckbox.some((ele) => ele === "Hall of Fame")) {
          const payload = {
            userId: res?.data?.userId,
            author: profileData?.first_name + " " + profileData?.last_name,
            month: moment().month() + 1,
            year: moment().year(),
            paragraphs: values.content,
            status: values.halloffamedropdown,
          };
          AddHallofFame(payload, token)
            .then((res) => {
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
              toast.current.show({
                severity: "error",
                summary: getErrorMessage(err),
              });
            });
        }
        if (values.selectedCheckbox.some((ele) => ele === "Super Looper")) {
          const payload = {
            userId: res?.data?.userId,
            author: profileData?.first_name + " " + profileData?.last_name,
            month: moment().month() + 1,
            year: moment().year(),
            paragraphs: values.content,
          };
          AddSuperLooper(payload, token)
            .then((res) => {
              setIsLoading(false);

              toast.current.show({
                severity: "success",
                summary: res?.data?.message || "Super Looper added",
              });
            })
            .catch((err) => {
              toast.current.show({
                severity: "error",
                summary: getErrorMessage(err),
              });
              setIsLoading(false);
            });
        }
        if (values.selectedCheckbox.some((ele) => ele === "courtesy")) {
          AddCourtesy(res?.data?.userId, token)
            .then((res) => {
              setIsLoading(false);
              toast.current.show({
                severity: "success",
                summary: res?.data?.message || "Courtesy added",
              })
            })
            .catch((err) => {
              toast.current.show({
                severity: "error",
                summary: getErrorMessage(err),
              });
              setIsLoading(false);
            });
        }
        action.resetForm();
        setTimeout(() => {
          setIsLoading(false);
          navigate("/user-management");
        }, 1000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: getErrorMessage(err),
        });
      });
  };

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    handleBlur,
  } = useFormik({
    initialValues,
    validationSchema: UserDetailsSchema(
      isAgentEmailInput,
      isAgentTelephoneInput
    ),
    onSubmit: (values, action) => addUserHandler(values, action),
  });

  const handleOnChange = (e, setFieldValue, setFieldTouched, values) => {
    if (e.target.files.length) {
      setFieldValue(e.target.name, e?.target?.files[0]);
    } else {
      setFieldValue(e.target.name, values[e.target.name]);
    }
  };

  // languages
  const getLanguages = async () => {
    getAllLanguage(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );

        setFieldValue("voice_languages", arr);
      })
      .catch((err) => {});
  };

  const getVoiceType = async () => {
    getAllVoiceType(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("voice_types", arr);
      })
      .catch((err) => {});
  };

  const getConnectivity = async () => {
    getAllConnectivity(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("Connectivity", arr);
      })
      .catch((err) => {});
  };

  const getVoiceTalentData = async () => {
    getVoiceTalent(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getProducerData = async () => {
    getProducer(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getDirectorData = async () => {
    getDirector(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getAgentData = async () => {
    getAgent(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );
        setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getEngineerData = async () => {
    getEngineer(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );

        setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const getRecordingStudioData = async () => {
    getRecordingstudio(token)
      .then((res) => {
        let arr = [];
        res?.data?.data.map((ele) =>
          arr.push({
            id: ele.id,
            value: ele.name_en,
            label: ele.name_en,
          })
        );

        setFieldValue("speciality", arr);
      })
      .catch((err) => {});
  };

  const onUserTypeChangeHandler = async (val) => {
    setFieldValue("user_type", val);
    setFieldValue("specialityChosen", []);
    setFieldValue("", []);
    switch (val) {
      case "voicetalent":
        // setIsAgent(true);
        await getVoiceTalentData();
        break;
      case "producer":
        await getProducerData();
        setIsAgent(false);
        break;
      case "director":
        setIsAgent(false);
        await getDirectorData();
        break;
      case "agent":
        setIsAgent(true);
        await getAgentData();
        break;
      case "engineer":
        await getEngineerData();
        setIsAgent(false);
        break;
      case "recordingstudio":
        await getRecordingStudioData();
        setIsAgent(false);
        break;
      default:
        break;
    }
  };

  const onAgentEmailChange = (val) => {
    setFieldValue("agent_email", val);
    setIsEmailAgentInput(true);
  };

  const onAgentTeleChange = (val) => {
    setFieldValue("agent_telephone", val);
    setIsAgentTelephone(true);
  };

  const onhandleBlur = (field, setFieldValue) => () => {
    switch (field.name) {
      case "chosenLanguage":
        touched.chosenLanguage = true;
        break;
      case "chosenVoice":
        touched.chosenVoice = true;
        break;
      case "specialityChosen":
        touched.specialityChosen = true;
        break;
      case "chosenConnectivity":
        touched.chosenConnectivity = true;
      // eslint-disable-next-line no-fallthrough
      default:
        break;
    }
    setFieldValue(field.name, field.value);
  };

  // const checkHandler = () => {
  //   setChecked(!checked)
  // }

  // This will trigger Formik's onBlur event for the specified field
  // };

  const fetchCountries = async () => {
    await getAllCountry(token).then((res) => {
      setIsLoading(false);
      setCountries(res?.data?.data);
    });
  };

  const handleCountryChange = (isoCode) => {
    const countryObj = countries.find((ele) => ele.isoCode === isoCode);
    setSelectedCoun(countryObj.name);
    setSelectedCounCode(isoCode);
    fetchStates(isoCode);
    setFieldValue("country", isoCode);
  };

  const fetchStates = async (selectedCountryId) => {
    await getAllState(selectedCountryId, token).then((res) => {
      setIsLoading(false);
      setStates(res?.data?.data);
    });
  };

  const handleStateChange = (isoCode) => {
    const stateobj = states.find((ele) => ele.isoCode === isoCode);
    setSelectedStat(stateobj.name);
    setSelectedStatCode(isoCode);
    fetchCities(isoCode, values.country);
    setFieldValue("state", isoCode);
  };

  const fetchCities = async (stateId, countryCode) => {
    await getAllCity(stateId, countryCode, token).then((res) => {
      setIsLoading(false);
      setCities(res?.data?.data);
    });
  };

  const onChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
    }
  };

  useEffect(() => {
    async function getAllAPI() {
      await getLanguages();
      await getVoiceType();
      await getConnectivity();
      await fetchCountries();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isActive, setIsActive] = useState(false);

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const zoomIn = () => {
    const cropper = cropperRef.current.cropper;
    cropper.zoom(0.1);
  };

  // Function to handle zoom out
  const zoomOut = () => {
    const cropper = cropperRef.current.cropper;
    cropper.zoom(-0.1);
  };

  const handleHOFChange = (e) => {
    if (e.target.checked) {
      setDisableHOF(false)
      setDisableCourtesy(true); 
    }
    else {
      setDisableHOF(false)
      setDisableCourtesy(false);
    }
  }

  const handleCourtesyChange = (e) => {
    if (e.target.checked) {
      setDisableHOF(true)
      setDisableCourtesy(false); 
    }
    else {
      setDisableHOF(false)
      setDisableCourtesy(false);
    }
  }

  const navigate = useNavigate();
  return (
    <>
      <div className="back-touserdetails">
        {isLoading && (
          <div className="set-proper-line-in-all-page">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <Toast ref={toast} />
        <div className="userprofile-pics">
          <form onSubmit={handleSubmit} className="">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <svg
                  onClick={() => {
                    navigate(-1);
                  }}
                  width="32"
                  height="24"
                  viewBox="0 0 32 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="cursor-pointer"
                >
                  <path
                    d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                    fill="black"
                  />
                </svg>
                <h6 className="mb-0">Back to User Details</h6>
              </div>
            </div>

            <div className="main-profile-all-cls-start">
              <label className="profile-cls-text mt-4 mb-4">
                Profile Details
              </label>
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-3 position-relative">
                    <label className="my-2">Upload profile image</label>
                    <div className="cropping-img-cls-all">
                      <input
                        type="file"
                        onChange={onChange}
                        style={{ width: "100%" }}
                        onClick={toggleClass}
                        className="files-name-edit"
                      />
                    </div>

                    <span className="upload-all-btns-cls-add">
                      {/* <button
                        className="btn btn-primary uploading-btn-all-time-cls"
                        type="button"
                        >
                        Upload
                      </button> */}
                    </span>
                  </div>
                  <div className="col-lg-3">
                    <label className="my-2">
                      User Email<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="UserEmail"
                      id="exampleFormControlInput2"
                      placeholder="Enter Your Email"
                      value={values.UserEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.UserEmail && touched.UserEmail ? (
                      <p className="form-error">{errors.UserEmail}</p>
                    ) : null}
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      First name<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      id="exampleFormControlInput2"
                      placeholder="Enter First Name"
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.firstName && touched.firstName ? (
                      <p className="form-error">{errors.firstName}</p>
                    ) : null}
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      Last Name<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      id="exampleFormControlInput3"
                      placeholder="Enter Last Name"
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.lastName && touched.lastName ? (
                      <p className="form-error">{errors.lastName}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row align-items-center">
                  <div
                    className={`col-lg-3 ${
                      isActive ? "addspacingcls" : "removespacingcls"
                    }`}
                  >
                    <div className="cropper-set-properly">
                      <Cropper
                        type="file"
                        name="uploadimg"
                        className="form-control set-to-auto-height"
                        accept="image/png, image/jpeg, image/jpg image/bmp"
                        id="exampleFormControlInput1"
                        style={{ width: "100%", border: "none", padding: "0" }}
                        placeholder="File Name"
                        onBlur={handleBlur}
                        ref={cropperRef}
                        zoomTo={0.5}
                        zoomable={true}
                        initialAspectRatio={1}
                        preview=".img-preview"
                        src={image}
                        viewMode={1}
                        minCropBoxHeight={10}
                        minCropBoxWidth={10}
                        background={false}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                        guides={true}
                        onChange={(e) =>
                          handleOnChange(
                            e,
                            setFieldValue,
                            setFieldTouched,
                            values
                          )
                        }
                      />
                      <div
                        className={` ${
                          isActive
                            ? "proper-to-plus-minus"
                            : "removeproper-to-plus-minus"
                        }`}
                      >
                        <button
                          onClick={zoomIn}
                          className="zooming-in"
                          type="button"
                        >
                          <span className="zoomin">
                            <svg
                              width="18px"
                              height="18px"
                              viewBox="0 0 32 32"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Page-1"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <g
                                  id="Icon-Set"
                                  transform="translate(-308.000000, -1139.000000)"
                                  fill="#000000"
                                >
                                  <path
                                    d="M321.46,1163.45 C315.17,1163.45 310.07,1158.44 310.07,1152.25 C310.07,1146.06 315.17,1141.04 321.46,1141.04 C327.75,1141.04 332.85,1146.06 332.85,1152.25 C332.85,1158.44 327.75,1163.45 321.46,1163.45 L321.46,1163.45 Z M339.688,1169.25 L331.429,1161.12 C333.592,1158.77 334.92,1155.67 334.92,1152.25 C334.92,1144.93 328.894,1139 321.46,1139 C314.026,1139 308,1144.93 308,1152.25 C308,1159.56 314.026,1165.49 321.46,1165.49 C324.672,1165.49 327.618,1164.38 329.932,1162.53 L338.225,1170.69 C338.629,1171.09 339.284,1171.09 339.688,1170.69 C340.093,1170.3 340.093,1169.65 339.688,1169.25 L339.688,1169.25 Z M326.519,1151.41 L322.522,1151.41 L322.522,1147.41 C322.522,1146.85 322.075,1146.41 321.523,1146.41 C320.972,1146.41 320.524,1146.85 320.524,1147.41 L320.524,1151.41 L316.529,1151.41 C315.978,1151.41 315.53,1151.59 315.53,1152.14 C315.53,1152.7 315.978,1153.41 316.529,1153.41 L320.524,1153.41 L320.524,1157.41 C320.524,1157.97 320.972,1158.41 321.523,1158.41 C322.075,1158.41 322.522,1157.97 322.522,1157.41 L322.522,1153.41 L326.519,1153.41 C327.07,1153.41 327.518,1152.96 327.518,1152.41 C327.518,1151.86 327.07,1151.41 326.519,1151.41 L326.519,1151.41 Z"
                                    id="zoom-in"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </span>
                        </button>
                        <button
                          onClick={() => zoomOut()}
                          className="zoom-out"
                          type="button"
                        >
                          <span className="zoomin">
                            <svg
                              width="18px"
                              height="18px"
                              viewBox="0 0 32 32"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g
                                id="Page-1"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <g
                                  id="Icon-Set"
                                  transform="translate(-360.000000, -1139.000000)"
                                  fill="#000000"
                                >
                                  <path
                                    d="M373.46,1163.45 C367.17,1163.45 362.071,1158.44 362.071,1152.25 C362.071,1146.06 367.17,1141.04 373.46,1141.04 C379.75,1141.04 384.85,1146.06 384.85,1152.25 C384.85,1158.44 379.75,1163.45 373.46,1163.45 L373.46,1163.45 Z M391.688,1169.25 L383.429,1161.12 C385.592,1158.77 386.92,1155.67 386.92,1152.25 C386.92,1144.93 380.894,1139 373.46,1139 C366.026,1139 360,1144.93 360,1152.25 C360,1159.56 366.026,1165.49 373.46,1165.49 C376.672,1165.49 379.618,1164.38 381.932,1162.53 L390.225,1170.69 C390.629,1171.09 391.284,1171.09 391.688,1170.69 C392.093,1170.3 392.093,1169.65 391.688,1169.25 L391.688,1169.25 Z M378.689,1151.41 L368.643,1151.41 C368.102,1151.41 367.663,1151.84 367.663,1152.37 C367.663,1152.9 368.102,1153.33 368.643,1153.33 L378.689,1153.33 C379.23,1153.33 379.669,1152.9 379.669,1152.37 C379.669,1151.84 379.23,1151.41 378.689,1151.41 L378.689,1151.41 Z"
                                    id="zoom-out"
                                  ></path>
                                </g>
                              </g>
                            </svg>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-lg-3 ${
                      isActive ? "addspacingcls" : "removespacingcls"
                    }`}
                  >
                    <div className="first-side-btncrop m-auto text-center">
                      <button
                        onClick={getCropData}
                        className={`btn btn-primary box ${
                          isActive ? "activeimg" : "boxadd"
                        }`}
                        type="button"
                      >
                        Crop Image
                      </button>
                    </div>
                  </div>
                  <div
                    className={`col-lg-3 ${
                      isActive ? "addspacingcls" : "removespacingcls"
                    }`}
                  >
                    <div className="secondside-img">
                      <div className="box">
                        <div className="img-all-height-calc">
                          <img
                            alt=""
                            src={cropData}
                            className={`box ${
                              isActive ? "activeimg" : "boxadd"
                            }`}
                            style={{
                              width: "auto",
                              objectFit: "contain",
                              height: "250px",
                              maxWidth: "100%",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="upload-user-profile-cls">
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="my-2">Gender</label>
                    <select
                      name="gender"
                      value={values.gender}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Select Gender"
                    >
                      <option key="placeholder" value="" disabled hidden>
                        Select Gender
                      </option>
                      <option key="gender-male" value="1" label="Male">
                        Male
                      </option>
                      <option key="gender-female" value="2" label="Female">
                        Female
                      </option>
                      <option key="gender-non-binary" value="3" label="Non-Binary">
                        Non-Binary
                      </option>
                    </select>
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      {" "}
                      Country<span className="required">*</span>
                    </label>
                    <select
                      name="country"
                      value={values.country}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => handleCountryChange(e.target.value)}
                      onBlur={handleBlur}
                      placeholder="Select Country"
                    >
                      <option key="placeholder" value="" disabled hidden>
                        Select a Country
                      </option>
                      {countries.map((country) => (
                        <option key={country.isoCode} value={country.isoCode}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {errors.selectedCountry && touched.selectedCountry ? (
                      <p className="form-error">{errors.selectedCountry}</p>
                    ) : null}
                  </div>

                  <div className="col-lg-3">
                    <label className="my-2">
                      State<span className="required">*</span>
                    </label>
                    <select
                      name="state"
                      value={values.state}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => handleStateChange(e.target.value)}
                      onBlur={handleBlur}
                      placeholder="Select State"
                    >
                      <option key="placeholder" value="" disabled hidden>
                        Select a State
                      </option>
                      {states.map((state) => (
                        <option key={state.isoCode} value={state.isoCode}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    {errors.state && touched.state ? (
                      <p className="form-error">{errors.state}</p>
                    ) : null}
                  </div>
                  <div className="col-lg-3">
                    <label className="my-2">
                      City<span className="required">*</span>
                    </label>
                    <select
                      name="city"
                      value={values.city}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Select City"
                    >
                      <option key="placeholder" value="" disabled hidden>
                        Select a City
                      </option>
                      {cities.map((city, index) => (
                        <option
                          key={`city-${city.id || city.name || index}`}
                          value={city.id}
                        >
                          {city.name}
                        </option>
                      ))}
                    </select>
                    {/* {errors.city && touched.city ? (
                      <p className="form-error">{errors.city}</p>
                    ) : null} */}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="my-2">
                      Years Of Experience<span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="experience"
                      id="exampleFormControlInput2"
                      placeholder="Enter Years"
                      value={values.experience}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></input>
                    {errors.experience && touched.experience ? (
                      <p className="form-error">{errors.experience}</p>
                    ) : null}
                  </div>
                  {values.voice_languages && (
                    <div className="col-lg-3">
                      <label className="my-2">Languages</label>
                      <Select
                        name="chosenLanguage"
                        className="select-multiple-all-drop"
                        options={values.voice_languages}
                        placeholder="Select Voice Languages"
                        onBlur={onhandleBlur(
                          {
                            name: "chosenLanguage",
                            value: values.chosenLanguage,
                          },
                          setFieldValue
                        )}
                        value={values.chosenLanguage}
                        isMulti
                        onChange={(selectedLanguages) => {
                          setFieldValue("chosenLanguage", selectedLanguages);
                        }}
                      />
                    </div>
                  )}

                  {values.voice_types && (
                    <div className="col-lg-3">
                      <label className="my-2">Voice Type</label>
                      <Select
                        name="chosenVoice"
                        options={values.voice_types}
                        placeholder="Select voice Type"
                        value={values.chosenVoice}
                        className="select-multiple-all-drop"
                        isMulti
                        onBlur={onhandleBlur(
                          { name: "chosenVoice", value: values.chosenVoice },
                          setFieldValue
                        )}
                        onChange={(selectedVoiceType) => {
                          setFieldValue("chosenVoice", selectedVoiceType);
                        }}
                      />
                    </div>
                  )}
                  <div className="col-lg-3">
                    <label className="my-2">
                      User Type<span className="required">*</span>
                    </label>
                    <select
                      name="user_type"
                      value={values.user_type}
                      className="form-select"
                      aria-label="Default select example"
                      onBlur={handleBlur}
                      onChange={(e) => onUserTypeChangeHandler(e.target.value)}
                    >
                      <option key="placeholder" value="" disabled hidden>
                        Select User types
                      </option>
                      <option key="user-type-voicetalent" value="voicetalent" label="Voicetalent">
                        Voice-talent
                      </option>
                      <option key="user-type-producer" value="producer" label="Producer">
                        Producer
                      </option>
                      <option key="user-type-director" value="director" label="Director">
                        Director
                      </option>
                      <option key="user-type-agent" value="agent" label="Agent">
                        Agent
                      </option>
                      <option key="user-type-engineer" value="engineer" label="Engineer">
                        Engineer
                      </option>
                      <option key="user-type-recordingstudio" value="recordingstudio" label="Studio">
                        Recording-studio
                      </option>
                    </select>
                    {errors.user_type && touched.user_type ? (
                      <p className="form-error">{errors.user_type}</p>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="upload-user-profile-cls">
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <label className="my-2">
                      User Role<span className="required">*</span>
                    </label>
                    <select
                      name="user_role"
                      value={values.user_role}
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option key="placeholder" value="" disabled hidden>
                        Select User Role
                      </option>
                      <option key="role-admin" value="Admin" label="Admin">
                        Admin
                      </option>
                      <option key="role-user" value="User" label="User">
                        User
                      </option>
                      <option key="role-ambassador" value="Ambassador" label="Ambassador">
                        Ambassador
                      </option>
                    </select>
                    {errors.user_role && touched.user_role ? (
                      <p className="form-error">{errors.user_role}</p>
                    ) : null}
                  </div>
                  <div className="col">
                    <div className="text-left">
                      <label className="my-2 mb-2">Select Age Value</label>

                      <div className="newmultirangslider-cls-add-custom">
                        <MultiRangeSlider
                          name="range"
                          baseClassName="multi-range-slider-black"
                          minValue={minValue}
                          maxValue={maxValue}
                          placeholder="Select Voice Languages"
                          onBlur={handleBlur}
                          value={values.range}
                          onInput={(e) => {
                            setMinValue(e.minValue);
                            setMaxValue(e.maxValue);
                          }}
                          onChange={(e) => {
                            setMinValue2(e.minValue);
                            setMaxValue2(e.maxValue);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3 align-items-center">
                  <div className="col-lg-2">
                    <div className="checking-all">
                      <label className="d-flex align-items-center">
                        <input
                          name="selectedCheckbox"
                          type="checkbox"
                          onChange={handleChange}
                          className="me-2"
                          value="Super Looper"
                        />
                        Super Looper
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="checking-all">
                      <label className="d-flex align-items-center">
                        <input
                          name="selectedCheckbox"
                          type="checkbox"
                          onChange={(e) => {handleHOFChange(e); handleChange(e)}}
                          className="me-2"
                          value="Hall of Fame"
                          disabled={disableHOF}
                        />
                        Hall of Fame
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-2">
                    <div className="checking-all">
                      <label className="d-flex align-items-center">
                        <input
                          name="selectedCheckbox"
                          type="checkbox"
                          onChange={handleCourtesyChange}
                          className="me-2"
                          value="courtesy"
                          disabled={disableCourtesy}
                        />
                        Courtesy ($10)
                      </label>
                    </div>
                  </div>
                  {values.selectedCheckbox.some(
                    (ele) => ele === "Hall of Fame"
                  ) && (
                    <div className="col-lg-4">
                      <label className="my-2">
                        Type<span className="required">*</span>
                      </label>
                      <select
                        name="halloffamedropdown"
                        className="form-select"
                        value={values.halloffamedropdown}
                        aria-label="Default select example"
                        placeholder="Select Type"
                        onChange={handleChange}
                      >
                        <option key="placeholder" value="" disabled hidden>
                          Select Type
                        </option>
                        <option key="hof-excellence" value="1">Excellence - ($10)</option>

                        <option key="hof-silver" value="2">Silver - ($25)</option>
                        <option key="hof-gold" value="3">Gold - ($50)</option>
                        <option key="hof-founder" value="4">Founder - ($5)</option>
                      </select>
                    </div>
                  )}
                  <div className="col-lg-4">
                    <label className="my-2"> Bio/Description</label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Please Enter Paragraph Here"
                      name="content"
                      id="floatingTextarea"
                      value={values.content}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                  </div>
                </div>
                <hr />

                <div className="main-profile-all-cls-start">
                  <label className="profile-cls-text mt-2 mb-4">
                    Socials Details
                  </label>
                  <div className="details-all-name upload-user-profile-cls">
                    <div className="row">
                      <div className="col-lg-4">
                        <label className="my-2">Facebook</label>
                        <input
                          type="text"
                          name="facebook"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Enter Your Facebook Username here"
                          value={values.facebook}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        ></input>
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Instagram</label>
                        <input
                          type="text"
                          name="instagram"
                          className="form-control"
                          id="exampleFormControlInput2"
                          placeholder="Enter Your Instagram Username here"
                          value={values.instagram}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        ></input>
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Website</label>
                        <input
                          type="text"
                          name="website"
                          className="form-control"
                          id="exampleFormControlInput3"
                          placeholder="Enter Your Website Url here"
                          value={values.website}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        ></input>
                        {/* {errors.website && touched.website ? (
                    <p className="form-error">{errors.website}</p>
                  ) : null} */}
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                {isAgent && (
                  <div className="main-profile-all-cls-start">
                    <label className="profile-cls-text mt-2 mb-4">
                      Agent Details
                    </label>
                    <div className="details-all-name upload-user-profile-cls">
                      <div className="row">
                        <div className="col-lg-4">
                          <label className="my-2">Agent Name</label>
                          <input
                            type="text"
                            name="agent_name"
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="File Name"
                            value={values.agent_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          ></input>
                          {errors.agent_name && touched.agent_name ? (
                            <p className="form-error">{errors.agent_name}</p>
                          ) : null}
                        </div>
                        <div className="col-lg-4">
                          <label className="my-2">Agency Name</label>
                          <input
                            type="text"
                            name="agency_name"
                            className="form-control"
                            id="exampleFormControlInput2"
                            placeholder="Write here"
                            value={values.agency_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          ></input>
                        </div>
                        <div className="col-lg-4">
                          <label className="my-2">Telephone</label>
                          <input
                            type="number"
                            name="agent_telephone"
                            className="form-control"
                            id="exampleFormControlInput3"
                            placeholder="Write here"
                            value={values.agent_telephone}
                            onChange={(e) => {
                              onAgentTeleChange(e.target.value);
                            }}
                            onBlur={handleBlur}
                          ></input>
                          {errors.agent_telephone && touched.agent_telephone ? (
                            <p className="form-error">
                              {errors.agent_telephone}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div className="col-lg-4">
                          <label className="my-2">Email</label>
                          <input
                            type="text"
                            name="agent_email"
                            className="form-control"
                            id="exampleFormControlInput1"
                            placeholder="File Name"
                            value={values.agent_email}
                            onChange={(e) => {
                              onAgentEmailChange(e.target.value);
                            }}
                            onBlur={handleBlur}
                          ></input>
                          {errors.agent_email && touched.agent_email ? (
                            <p className="form-error">{errors.agent_email}</p>
                          ) : null}
                        </div>
                        <div className="col-lg-4">
                          <label className="my-2">Website</label>
                          <input
                            type="text"
                            name="website1"
                            className="form-control"
                            id="exampleFormControlInput2"
                            placeholder="Write here"
                            value={values.website1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          ></input>
                        </div>
                        <div className="col-lg-4">
                          <label className="my-2">Address</label>
                          <input
                            type="text"
                            name="agent_address"
                            className="form-control"
                            id="exampleFormControlInput3"
                            placeholder="Write here"
                            value={values.agent_address}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          ></input>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                )}

                <div className="main-profile-all-cls-start">
                  <label className="profile-cls-text mt-2 mb-4">
                    Other Details
                  </label>
                  <div className="details-all-name upload-user-profile-cls">
                    <div className="row">
                      {values.speciality && (
                        <div className="col-lg-4">
                          <label className="my-2">Specialty</label>
                          <Select
                            name="specialityChosen"
                            options={values.speciality}
                            placeholder="Select speciality"
                            value={values.specialityChosen}
                            className="select-multiple-all-drop"
                            isMulti
                            onBlur={onhandleBlur(
                              {
                                name: "specialityChosen",
                                value: values.specialityChosen,
                              },
                              setFieldValue
                            )}
                            onChange={(selectedSpeciality) => {
                              setFieldValue(
                                "specialityChosen",
                                selectedSpeciality
                              );
                            }}
                          />
                        </div>
                      )}
                      <div className="col-lg-4">
                        <label className="my-2">
                          Badge Status<span className="required">*</span>
                        </label>
                        <select
                          name="badge_status"
                          value={values.badge_status}
                          className="form-select"
                          aria-label="Default select example"
                          onChange={handleChange}
                          placeholder="Select Badge"
                          onBlur={handleBlur}
                        >
                          <option key="placeholder" value="" disabled hidden>
                            Select Badge
                          </option>
                          <option key="badge-silver" value="Silver" label="Silver">
                            Silver
                          </option>
                          <option key="badge-golden" value="Golden" label="Golden">
                            Golden
                          </option>
                          <option key="badge-platinum" value="Platinum" label="Platinum">
                            Platinum
                          </option>
                        </select>
                        {errors.badge_status && touched.badge_status ? (
                          <p className="form-error">{errors.badge_status}</p>
                        ) : null}
                      </div>
                      <div className="col-lg-4">
                        <label className="my-2">Union/ Nonunion?</label>
                        <select
                          name="union"
                          value={values.union}
                          className="form-select"
                          aria-label="Default select example"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Select any Option"
                        >
                          <option key="placeholder" value="" disabled hidden>
                            Select any Option{" "}
                          </option>
                          <option key="union-yes" value={true} label="Yes">
                            Yes
                          </option>
                          <option key="union-no" value={false} label="No">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-lg-4">
                        <label className="my-2">Home Studio?</label>
                        <select
                          name="home_studio"
                          value={values.home_studio}
                          className="form-select"
                          aria-label="Default select example"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Select any Option"
                        >
                          <option key="placeholder" value="" disabled hidden>
                            Select Any Option
                          </option>
                          <option key="yes" value="true" label="Yes">
                            Yes
                          </option>
                          <option key="no" value="false" label="No">
                            No
                          </option>
                        </select>
                      </div>
                      {values.Connectivity && (
                        <div className="col-lg-4">
                          <label className="my-2">Connectivity</label>
                          <Select
                            name="chosenConnectivity"
                            options={values.Connectivity}
                            placeholder="Select Connectivity"
                            value={values.chosenConnectivity}
                            onBlur={onhandleBlur(
                              {
                                name: "chosenConnectivity",
                                value: values.chosenConnectivity,
                              },
                              setFieldValue
                            )}
                            className="select-multiple-all-drop"
                            isMulti
                            onChange={(selectedConnectivity) => {
                              setFieldValue(
                                "chosenConnectivity",
                                selectedConnectivity
                              );
                            }}
                          />
                        </div>
                      )}
                      <div className="col-lg-4">
                        <label className="my-2">Discoverable?</label>
                        <select
                          name="discoverable"
                          value={values.discoverable}
                          className="form-select"
                          aria-label="Default select example"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Select Any Option"
                        >
                          <option key="placeholder" value="" disabled hidden>
                            Select Any Option
                          </option>
                          <option key="yes" value="true" label="Yes">
                            Yes
                          </option>
                          <option key="no" value="false" label="No">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="right-sidebtn-add text-end">
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      onClick={() => {
                        navigate(-1);
                      }}
                      type="button"
                      className="btn btn-primary outline-btn-cls me-2"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary filled-btn-cls"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              {/* </div>
            </div> */}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserDetails;
